import { FormControl, TextField, InputAdornment, FormHelperText } from "@mui/material"
import { Add, Remove } from "@mui/icons-material"
import LightBlueIconButton from "../buttons/LightBlueIconButton"
import useInput from "../../../hooks/use_input"
import useAppStore from "store/app"
import useTranslation from "hooks/use_translation"
import { useTheme } from "@mui/material/styles"

const HumanWeight = () => {
  const id = "weight"
  const updateFieldInputValue = useAppStore((state) => state.updateFieldInputValue)
  const { fields } = useTranslation()
  const theme = useTheme()

  const validate = (value) => {
    if (value === "") return "This field is required"

    return ""
  }

  const { handleChange, inputValue, errorMessage, handleBlur } = useInput(id, validate)

  const handleIncrement = () => {
    let formattedValue

    formattedValue = parseInt(inputValue)

    if (!Number.isInteger(formattedValue)) {
      formattedValue = 0
    }

    updateFieldInputValue(id, formattedValue + 1)
  }

  const handleDecrement = () => {
    let formattedValue

    formattedValue = parseInt(inputValue)

    if (!Number.isInteger(formattedValue)) {
      formattedValue = 0
      updateFieldInputValue(id, formattedValue)
    } else {
      updateFieldInputValue(id, formattedValue - 1)
    }
  }

  const handleInputChange = (event) => {
    const newValue = parseInt(event.target.value, 10)

    const weightValue = isNaN(newValue) ? 0 : newValue

    if (weightValue > 130) return

    const modifiedEvent = {
      ...event,
      target: { ...event.target, value: weightValue },
    }
    handleChange(modifiedEvent)
  }

  const IncreaseAction = ({ position }) => (
    <InputAdornment position={position}>
      <LightBlueIconButton onClick={handleDecrement}>
        <Remove />
      </LightBlueIconButton>
    </InputAdornment>
  )

  const DecreaseAction = ({ position }) => (
    <InputAdornment position={position}>
      <LightBlueIconButton onClick={handleIncrement}>
        <Add />
      </LightBlueIconButton>
    </InputAdornment>
  )
  return (
    <FormControl fullWidth>
      <TextField
        type="number"
        fullWidth
        value={inputValue}
        onChange={handleInputChange}
        onBlur={handleBlur}
        variant="outlined"
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "16px",
            backgroundColor: "#FFF",
            height: 80,
            fontSize: 32,
            fontWeight: 500,
          },
        }}
        inputProps={{ style: { textAlign: "center" } }}
        InputProps={{
          startAdornment:
            theme.direction === "rtl" ? (
              <DecreaseAction position="start" />
            ) : (
              <IncreaseAction position="start" />
            ),
          endAdornment:
            theme.direction === "rtl" ? (
              <IncreaseAction position="end" />
            ) : (
              <DecreaseAction position="end" />
            ),
        }}
      />
      <FormHelperText variant="body2" sx={{ textAlign: "center", fontWeight: 700 }}>
        {fields?.weight_hint}
      </FormHelperText>
      <FormHelperText variant="body2">{errorMessage}</FormHelperText>
    </FormControl>
  )
}

export default HumanWeight
